import {
    LabelGroupedData, Label, del_label, del_label_uids, label_insert, qry_labels,
    update_label, qry_labels_by_uid, qry_label,
    qry_labels_all,
    delLabelByUid,
    updateUser,
    updateLabelRemark,
    updateLabelAvatar
} from "../db/t_label";
import { User } from "../db/t_user";
import Context from "./context";

export default class LabelController {

    public static async GetAllLabels(ctx: Context):
        Promise<{ error?: any, labels?: LabelGroupedData[] }> {
        const r = await qry_labels_all(ctx.db)
        if (r.labels && r.labels.length > 0) {
            return r
        }
        return await this.GetRemote(ctx, 0, 10000)
    }

    public static async GetLabels(ctx: Context, skip: number, pageSize: number, search?: string):
        Promise<{ error?: any, labels?: LabelGroupedData[] }> {
        const r = await qry_labels(ctx.db, skip, pageSize, search)
        if (r.labels && r.labels.length > 0) {
            return r
        }
        const r1 = await this.GetRemote(ctx, 0, 10000)
        if (search && search.length > 0) {
            r1.labels = r1.labels?.filter((v) => {
                v.label.includes(search)
            })
        }
        return r1
    }
    public static async QryLabelsByUid(ctx: Context, uid: number):
        Promise<{ error?: any, labels?: { label: string }[] }> {
        return await qry_labels_by_uid(ctx.db, uid)
    }
    public static async QryLabel(ctx: Context, label: string):
        Promise<{ error?: any, labels?: { label: string }[] }> {
        return await qry_label(ctx.db, label)
    }

    public static async GetRemote(ctx: Context, skip: number, pageSize: number): Promise<{ error?: any, total?: number, labels?: LabelGroupedData[] }> {
        const r0 = await ctx.conn.Call("/v1/sdk/friend/label/list", { skip: skip, limit: pageSize });
        if (r0.code === 0) {
            //{ total: number, lables: { label: string, users?: User[] }[] }
            if (r0.data && r0.data.lables && r0.data.lables.length > 0) {
                const lables = r0.data.lables as LabelGroupedData[]
                const list: Label[] = []
                lables.forEach(v => {
                    const label = v.label
                    if (v.users && v.users.length > 0) {
                        v.users.forEach(user => {
                            const item = user as any as Label
                            item.label = label
                            list.push(item)
                        })
                    } else {
                        list.push({ label: label } as Label)
                    }
                })
                const total = r0.data.total
                await label_insert(ctx.db, list)
                return { total: total, labels: lables }
            } else {
                return { error: null }
            }
        } else {
            return { error: r0.msg }
        }
    }

    //通讯录标签列表 "type": 0-删除用户，1-删除标签
    public static async DelLabelUids(ctx: Context, label: string, uids: number[]): Promise<{ error?: any }> {
        const r = await ctx.conn.Call("/v1/sdk/friend/label/delete", { label: label, uids: uids, type: 0 });
        if (r.code === 0) {
            return await del_label_uids(ctx.db, label, uids)
        } else {
            return { error: r.msg }
        }
    }


    public static async DelLabel(ctx: Context, label: string): Promise<{ error?: any }> {
        const r = await ctx.conn.Call("/v1/sdk/friend/label/delete", { label: label, uids: [], type: 1 });
        if (r.code === 0) {
            return await del_label(ctx.db, label)
        } else {
            return { error: r.msg }
        }
    }
    public static async DelLabelByUid(ctx: Context, uid: number): Promise<{ error?: any }> {
        return await delLabelByUid(ctx.db, uid)
    }
    public static async UpdateUser(ctx: Context, user: User) {
        return await updateUser(ctx.db, user)
    }

    public static async UpdateLabelRemark(ctx: Context, uid: number, remark: string) {
        return await updateLabelRemark(ctx.db, uid, remark)
    }

    public static async UpdateLabelAvatar(ctx: Context, uid: number, avatar: string) {
        return await updateLabelAvatar(ctx.db, uid, avatar)
    }


    public static async AddLabel(ctx: Context, label: string, users: User[], type: 0 | 1): Promise<{ error?: any, labels?: Label[] }> {
        const uids = users.map(v => v.uid)
        //type 0追加，1 创建
        const r = await ctx.conn.Call("/v1/sdk/friend/label/add", { label: label, uids: uids, type: type });
        if (r.code === 0) {
            const labels: Label[] = []
            if (users.length > 0) {
                users.forEach(v => {
                    const item = v as any as Label
                    item.label = label
                    labels.push(item)
                })
            } else {
                labels.push({ label: label } as Label)
            }
            await label_insert(ctx.db, labels)
            return { labels: labels }
        } else {
            return { error: r.msg }
        }
    }

    public static async UpdateLabel(ctx: Context, oldeLabel: string, newLabel: string): Promise<{ error?: any, }> {
        const r = await ctx.conn.Call("/v1/sdk/friend/label/modify", { old_label: oldeLabel, new_label: newLabel });
        if (r.code === 0) {
            return await update_label(ctx.db, oldeLabel, newLabel)
        } else {
            return { error: r.msg }
        }
    }
}